export default "__VITE_ASSET__r5QeSS$o__"